
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnerUser",
      function () {
        return require("private-next-pages/partnerUser/index.tsx");
      }
    ]);
  